import { DoqType, ResponsiveDoqWithSpeechBubble } from '@ardoq/doq';
import styled from 'styled-components';
import { colors } from '@ardoq/design-tokens';
import { t, Trans } from '@ardoq/i18n';
import { Link } from '@ardoq/link';
import { getPreAppI18nLocale } from 'preAppI18nBootstrap';

const Wrapper = styled.div`
  background-color: ${colors.white950};
  border-radius: 20px;
`;

export const CreateOrgPageGone = () => {
  const i18nLocale = getPreAppI18nLocale();
  return (
    <Wrapper>
      <ResponsiveDoqWithSpeechBubble
        title={t(i18nLocale, 'createOrg:title', 'New way to sign up')}
        message={
          <p>
            <Trans
              i18nKey="createOrg:body"
              defaults="To get started with the new, guided onboarding to Ardoq, <supportLink>email our friendly customer service team</supportLink>, or <demoLink>schedule a demo here</demoLink>."
              components={{
                supportLink: <Link href="mailto:support@ardoq.com" hideIcon />,
                demoLink: (
                  <Link
                    href="https://content.ardoq.com/schedule-demo"
                    hideIcon
                  />
                ),
              }}
            />
          </p>
        }
        doqType={DoqType.PAGE_GONE}
      />
    </Wrapper>
  );
};
